document.addEventListener("DOMContentLoaded", function () {
    const allFaqComponents = document.querySelectorAll('[data-faq-section]');

    if (!allFaqComponents.length) return;

    allFaqComponents.forEach(faqComponent => {
        const faqItems = faqComponent.querySelectorAll('.faq-component-item');

        faqItems.forEach(item => {
            item.addEventListener('click', () => {
                toggleFaqItem(item, faqItems);
            });
        });

        if (faqItems.length > 0) {
            toggleFaqItem(faqItems[0], faqItems);
        }
    });

    /**
     * Toggles the selected FAQ item and closes all others
     * @param {HTMLElement} item - The clicked FAQ item element
     * @param {NodeListOf<HTMLElement>} allItems - All FAQ items in the same section
     */
    function toggleFaqItem(item, allItems) {
        const answer = item.querySelector('.faq-component-item-answer');
        if (!answer) return;

        const isOpen = answer.classList.contains('open');

        closeAllOtherItems(item, allItems);
        toggleCurrentItem(item, answer, isOpen);
    }

    /**
     * Closes all FAQ items except the one passed as active
     * @param {HTMLElement} activeItem - The currently clicked item
     * @param {NodeListOf<HTMLElement>} allItems - All FAQ items in the section
     */
    function closeAllOtherItems(activeItem, allItems) {
        allItems.forEach(otherItem => {
            if (otherItem === activeItem) return;

            const otherAnswer = otherItem.querySelector('.faq-component-item-answer');
            const icon = getIconElement(otherItem);
            const hoverIcon = getHoverIconElement(otherItem);

            otherItem.classList.remove('selected');

            if (icon) {
                icon.classList.add('plus-icon');
                icon.classList.remove('minus-icon');
            }

            if (hoverIcon) {
                hoverIcon.classList.add('plus-circle-icon');
                hoverIcon.classList.remove('minus-circle-icon');
            }

            if (otherAnswer) {
                otherAnswer.classList.remove('open');
                otherAnswer.style.maxHeight = null;
            }
        });
    }

    /**
     * Toggles the selected FAQ item (open/close animation, icons, state)
     * @param {HTMLElement} item - The clicked FAQ item
     * @param {HTMLElement} answer - The answer content element inside the item
     * @param {boolean} isOpen - Whether the item is already open
     */
    function toggleCurrentItem(item, answer, isOpen) {
        const icon = getIconElement(item);
        const hoverIcon = getHoverIconElement(item);

        answer.classList.toggle('open', !isOpen);
        answer.style.maxHeight = isOpen ? null : answer.scrollHeight + "px";
        item.classList.toggle('selected', !isOpen);

        if (icon) {
            icon.classList.toggle('plus-icon', isOpen);
            icon.classList.toggle('minus-icon', !isOpen);
        }

        if (hoverIcon) {
            hoverIcon.classList.toggle('plus-circle-icon', isOpen);
            hoverIcon.classList.toggle('minus-circle-icon', !isOpen);
        }
    }

    /**
     * Finds the main icon element inside a container (plus or minus)
     * @param {HTMLElement} container - The FAQ item
     * @returns {HTMLElement|null}
     */
    function getIconElement(container) {
        return container.querySelector('.plus-icon') || container.querySelector('.minus-icon');
    }

    /**
     * Finds the hover icon element inside a container (plus-circle or minus-circle)
     * @param {HTMLElement} container - The FAQ item
     * @returns {HTMLElement|null}
     */
    function getHoverIconElement(container) {
        return container.querySelector('.plus-circle-icon') || container.querySelector('.minus-circle-icon');
    }
});
